import React, { useCallback, useEffect, useState } from "react";
import classes from "../Management.module.scss";
import styles from "./DealerPipeline.module.scss";
import { getDealerAdminInspections } from "../../../services/dealerGarage";
import { formatDate, vehicleLabel, customerLabel, customerRefOf } from "./dealerAdmin";
import CustomerLink from "./CustomerLink";

const FILTERS = [
  { id: "open", label: "Open (requested, accepted or booked)" },
  { id: "Requested", label: "New requests" },
  { id: "pending", label: "Waiting on customer" },
  { id: "buy", label: "Customer is buying" },
  { id: "decline", label: "Customer passed" },
  { id: "all", label: "All" },
];

const paramsFor = (filter) => {
  if (filter === "Requested") return { status: "Requested" };
  if (filter === "pending") return { decision: "pending" };
  if (filter === "buy" || filter === "decline") return { decision: filter };
  return {};
};

const decisionLabel = (inspection) => {
  const value = inspection.decision && inspection.decision.value;
  if (value === "buy") return inspection.purchaseId ? "Bought" : "Buying";
  if (value === "decline") return "Passed";
  return inspection.status === "Completed" ? "Waiting" : "";
};

/**
 * Inspections list. Props: onOpen(id), refreshKey, onOpenCustomer(ref).
 */
const InspectionsSection = ({ onOpen, refreshKey, onOpenCustomer }) => {
  const [filter, setFilter] = useState("open");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    getDealerAdminInspections({ ...paramsFor(filter), limit: 300 })
      .then((res) => {
        const data = res?.message === "Success" ? res.data : [];
        setRows(filter === "open" ? data.filter((i) => ["Requested", "Accepted", "Scheduled"].includes(i.status)) : data);
      })
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, [filter]);

  useEffect(() => { load(); }, [load, refreshKey]);

  return (
    <div>
      <div className={classes.formButtons} style={{ alignItems: "center" }}>
        <label className={classes.formLabel} htmlFor="dsm-insp-filter">Show</label>
        <select id="dsm-insp-filter" className={classes.formInput} style={{ width: "auto", marginTop: 0 }} value={filter} onChange={(e) => setFilter(e.target.value)}>
          {FILTERS.map((f) => <option key={f.id} value={f.id}>{f.label}</option>)}
        </select>
        <button type="button" className={classes.tableButton} onClick={load}>Refresh</button>
      </div>
      <p className={styles.hint}>Inspection requests from both sites open here automatically. Talk it through, then ask for the deposit from the inspection - once it's paid, the request is accepted for you. Then book the date. To inspect a car for any other lead, use "Book an inspection" on the inquiry.</p>
      <div className={`${classes.tableContainer} ${styles.scrollTable}`}>
        <table className={classes.table}>
          <thead>
            <tr className={classes.tableHeaderRow}>
              <th className={classes.tableHead}>Requested</th>
              <th className={classes.tableHead}>Customer</th>
              <th className={classes.tableHead}>Vehicle</th>
              <th className={classes.tableHead}>Status</th>
              <th className={classes.tableHead}>Booked for</th>
              <th className={classes.tableHead}>Decision</th>
              <th className={classes.tableHead}></th>
            </tr>
          </thead>
          <tbody>
            {loading && rows.length === 0 && (
              <tr className={classes.tableRow}><td className={classes.tableData} colSpan={7}>Loading...</td></tr>
            )}
            {!loading && rows.length === 0 && (
              <tr className={classes.tableRow}><td className={classes.tableData} colSpan={7}>No inspections.</td></tr>
            )}
            {rows.map((inspection) => (
              <tr key={inspection._id} className={classes.tableRow}>
                <td className={classes.tableData}>{formatDate(inspection.createdAt)}</td>
                <td className={classes.tableData}>
                  <CustomerLink customer={customerRefOf(inspection, "inspection")} onOpen={onOpenCustomer}>{customerLabel(inspection)}</CustomerLink>
                </td>
                <td className={classes.tableData}>{vehicleLabel(inspection)}</td>
                <td className={classes.tableData}>{inspection.status}</td>
                <td className={classes.tableData}>{formatDate(inspection.scheduledFor)}</td>
                <td className={classes.tableData}>{decisionLabel(inspection)}</td>
                <td className={classes.tableData}>
                  <button type="button" className={classes.tableButton} onClick={() => onOpen(inspection._id)}>Manage</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InspectionsSection;
